import { Link } from "react-router-dom";
import { RLCard } from "../../../../../../components";
import { pathToSS } from "../../../../util";
import { InfoContent } from "./components";

import { useLocalSampleSummaryParams } from "../../../../hooks";
import styles from "./info.module.scss";

import { settings } from "../../../../../../shim/jsbridge";
import { COMPONENT_IDS, SECTIONS } from "../../../../consts";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { Tooltip } from "../common";
import { PDFExport } from "../../@types/PDFExport";

const { FEATURE_IS_REPORT_SUMMARY_DEFAULT_LANDING_PAGE } = settings;

type Props = PDFExport;

const SampleInformationCard = ({ isPdfView }: Props) => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const section = FEATURE_IS_REPORT_SUMMARY_DEFAULT_LANDING_PAGE
    ? SECTIONS.FILE_ANALYSIS.SAMPLE_DETAILS
    : "";

  return (
    <RLCard
      header={
        <RLCard.LinkHeader
          title={
            <Tooltip
              message={DESCRIPTIONS[COMPONENT_IDS.SAMPLE_INFORMATION]}
              placement="top"
            >
              <span>Sample Information</span>
            </Tooltip>
          }
          LinkComponent={
            <Link
              className={styles.link}
              to={pathToSS(hash, sourceId, section, relationshipId)}
              data-testid="report_summary_sample_information_link"
            >
              See Full Sample Information
            </Link>
          }
        />
      }
      content={
        <RLCard.Content>
          <InfoContent isPdfView={isPdfView} />
        </RLCard.Content>
      }
      data-testid="report_summary_sample_information_card"
    />
  );
};

export default SampleInformationCard;
